<ul
  role="menu"
  class="menu-bar"
  [ngClass]="{ 'menu-bar--no-image' : menuItems[0].value === 'No_Image' }"
  [formGroup]="formGroup">
  <ng-container *ngFor="let menuItem of menuItems">
    <li role="none" *ngIf="!menuItem.hidden" class="menu-list__item">
        <bulb-menubar-item-action
            *ngIf="!menuItem.model"
            [menuItem]="menuItem"
        ></bulb-menubar-item-action>
        <bulb-menubar-item-action
            *ngIf="menuItem.model"
            [menuItem]="menuItem"
            [formControlName]="menuItem.model"
        ></bulb-menubar-item-action>
    </li>
  </ng-container>
</ul>
